var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4590_14848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0.820334C28 0.577248 27.8922 0.346685 27.7056 0.190826C27.5191 0.0349668 27.2731 -0.030166 27.0338 0.0130918L8.87753 3.29434C8.48712 3.36494 8.20312 3.70483 8.20312 4.10158V9.45844L28 5.88068V0.820334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 19.413C7.33168 18.632 6.18138 18.1562 4.92188 18.1562C2.20795 18.1562 0 20.3641 0 23.0781C0 25.792 2.20795 27.9999 4.92188 27.9999C7.6358 27.9999 9.84375 25.792 9.84375 23.0781V10.8291L8.20312 11.1256V19.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3594 16.952C25.4879 16.171 24.3376 15.6953 23.0781 15.6953C20.3642 15.6953 18.1562 17.9032 18.1562 20.6171C18.1562 23.331 20.3642 25.539 23.0781 25.539C25.792 25.539 28 23.331 28 20.6171V7.54785L26.3594 7.84437V16.952Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4590_14848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notes-icon.b9c828a39bcae5e27b2c413eb5ea8365.svg";
export { ForwardRef as ReactComponent };